import { EINKOMMENSBONUS, GebaeudeTyp, HOTWATER_OPTIONS, MASSNAHMEN_DACH_OPTIONS_CURRENT, MASSNAHMEN_DACH_OPTIONS_NEW, MASSNAHMEN_DACH_OPTIONS_NEW_DECKE, MASSNAHMEN_DACH_OPTIONS_NEW_SPARREN, MASSNAHMEN_FASSADE_OPTIONS_CURRENT, MASSNAHMEN_FASSADE_OPTIONS_NEW, MASSNAHMEN_FENSTER_OPTIONS_CURRENT, MASSNAHMEN_FENSTER_OPTIONS_NEW, MASSNAHMEN_HEIZUNG_OPTIONS_CURRENT, MASSNAHMEN_HEIZUNG_OPTIONS_NEW, MASSNAHMEN_KELLER_OPTIONS_CURRENT, MASSNAHMEN_KELLER_OPTIONS_NEW, MASSNAHMEN_LUEFTUNG_OPTIONS_CURRENT, MASSNAHMEN_LUEFTUNG_OPTIONS_NEW, MASSNAHMEN_PHOTOVOLTAIK_OPTIONS_CURRENT, MASSNAHMEN_PHOTOVOLTAIK_OPTIONS_NEW, MASSNAHMEN_SOLARTHERMIE_OPTIONS_CURRENT, MASSNAHMEN_SOLARTHERMIE_OPTIONS_NEW, ROOF_ORIENTATIONS, VERBRAUCHS_EINHEITEN, VERBRAUCHS_EINHEITEN_GAS, VERBRAUCHS_EINHEITEN_HOLZ, VERBRAUCHS_EINHEITEN_OEL } from "./types.ts";

export interface MainPropertiesDeclare{
  key: MainPropertyKey;
  label: string; 
  type: "boolean" | "number" | "number_with_unit_current" | "number_with_unit_planned" | "number_verbrauch_current" | "number_verbrauch_planned" | "plz" | "year" | "year_based" | "string" | "options" | "gebaeude_typ" | "heated_segments"; 
  step?: number;
  min?: number;
  max?: number;
  decimals?: number;
  placeholder?: string | number;
  hint?: string;
  unit?: string;
  options?: Array<{label: string, value: string | number}>
  default: MainPropertyValue;
}

export const MAIN_PROPERTIES : Array<MainPropertiesDeclare> = [

  
    {key: "energie_kosten_current", label: "Energiekosten (aktuell)", type: "number_with_unit_current", max:10000, min:0, step: 0.01, placeholder:"0,13 €", unit:"€", default: undefined},
    {key: "energie_kosten_planned", label: "Energiekosten (geplant)", type: "number_with_unit_planned", max:10000, min:0, step: 0.01, placeholder:"0,13 €", unit:"€", default: undefined},

    {key: "gebaeude_typ", label: "Gebäude Typ", type: "gebaeude_typ", default: "sfh" as GebaeudeTyp},
    {key: "postleitzahl", label: "Postleitzahl", type: "plz", placeholder:10557, default: undefined},
    {key: "strasse", label: "Straße", type: "string", placeholder:"Musterstraße", default: undefined},
    {key: "hausnummer", label: "Hausnummer", type: "string", min:1, max:5000, placeholder:"42a", default: undefined},

    {key: "vollgeschosse", label: "Vollgeschosse", type: "number", placeholder:3, min:1, max:100, step: 1, default: undefined},
    {key: "wohneinheiten", label: "Wohneinheiten", min:1, max:100, type: "number", step: 1, placeholder: "2", default: undefined},
    {key: "baujahr", label: "Baujahr", type: "year", step: 1, placeholder:"1987", default: undefined},
    {key: "baujahr_base", label: "Baujahr", type: "year_based", step: 1, placeholder:"1987", default: undefined},
    {key: "wohnflaeche", label: "Wohnfläche m²", type: "number", placeholder:"120 m²", min:1, max:10000, step: 1,unit:"m²", default: undefined},
    {key: "privat", label: "Selbstnutzender Eigentümer<br>(angemeldeter Erstwohnsitz)", type: "boolean", default: true},

    {key: "verbrauchseinheit_oel_current", label: "Einheit", type: "options", options: VERBRAUCHS_EINHEITEN_OEL, default: VERBRAUCHS_EINHEITEN_OEL[0].value},
    {key: "verbrauchseinheit_gas_current", label: "Einheit", type: "options", options: VERBRAUCHS_EINHEITEN_GAS, default: VERBRAUCHS_EINHEITEN_GAS[0].value},
    {key: "verbrauchseinheit_holz_current", label: "Einheit", type: "options", options: VERBRAUCHS_EINHEITEN_HOLZ, default: VERBRAUCHS_EINHEITEN_HOLZ[0].value},
    {key: "verbrauchseinheit_andere_current", label: "Einheit", type: "options", options: VERBRAUCHS_EINHEITEN, default: VERBRAUCHS_EINHEITEN[0].value},

    {key: "verbrauchseinheit_oel_planned", label: "Einheit", type: "options", options: VERBRAUCHS_EINHEITEN_OEL, default: VERBRAUCHS_EINHEITEN_OEL[0].value},
    {key: "verbrauchseinheit_gas_planned", label: "Einheit", type: "options", options: VERBRAUCHS_EINHEITEN_GAS, default: VERBRAUCHS_EINHEITEN_GAS[0].value},
    {key: "verbrauchseinheit_holz_planned", label: "Einheit", type: "options", options: VERBRAUCHS_EINHEITEN_HOLZ, default: VERBRAUCHS_EINHEITEN_HOLZ[0].value},
    {key: "verbrauchseinheit_andere_planned", label: "Einheit", type: "options", options: VERBRAUCHS_EINHEITEN, default: VERBRAUCHS_EINHEITEN[0].value},


    {key: "oelverbrauch", label: "Ölverbrauch", type: "number_verbrauch_current", min:0, step: 100, unit:"l/Jahr", placeholder:"120 l/Jahr", default: undefined},
    {key: "gasverbrauch", label: "Gasverbrauch", type: "number_verbrauch_current", min:0, step: 100, unit:"kwh/Jahr", placeholder:"1200 kwh/Jahr", default: undefined},
    {key: "gasverbrauch_m3", label: "Gasverbrauch", type: "number_verbrauch_current", min:0, step: 1, unit:"m³/Jahr", placeholder:"1200 m³/Jahr", default: undefined},
    {key: "holzverbrauch", label: "Verbrauch von Pettets / Holz", type: "number_verbrauch_current", min:0, step: 100, unit:"kWH/Jahr", placeholder:"1200 kWh/Jahr", default: undefined},
    {key: "holzverbrauch_m3", label: "Verbrauch von Pettets / Holz", type: "number_verbrauch_current", min:0, step: 1, unit:"m³/Jahr", placeholder:"1200 m³/Jahr", default: undefined},
    {key: "holzverbrauch_t", label: "Verbrauch von Pettets / Holz", type: "number_verbrauch_current", min:0, step: 1, unit:"t/Jahr", placeholder:"1200 t/Jahr", default: undefined},
    {key: "holzverbrauch_kg", label: "Verbrauch von Pettets / Holz", type: "number_verbrauch_current", min:0, step: 100, unit:"kg/Jahr", placeholder:"1200 kg/Jahr", default: undefined},
    {key: "stromverbrauchdiodenheizung", label: "Stromverbrauch", type: "number_verbrauch_current", min:0, step: 100, unit:"kwh/Jahr", placeholder:"1200 kwh/Jahr", default: undefined},
    {key: "stromverbrauchwaermepumpe", label: "Verbrauch Wärmepumpe", type: "number_verbrauch_current", min:0, step: 100, unit:"kwh/Jahr", placeholder:"1200 kwh/Jahr", default: undefined},
    {key: "stromverbrauch", label: "Stromverbrauch", type: "number_verbrauch_current", min:0, step: 100, unit:"kwh/Jahr", placeholder:"1200 kwh/Jahr", default: undefined},

    {key: "oelverbrauch_planned", label: "Ölverbrauch", type: "number_verbrauch_planned", min:0, step: 100, unit:"l/Jahr", placeholder:"120 l/Jahr", default: undefined},
    {key: "gasverbrauch_planned", label: "Gasverbrauch", type: "number_verbrauch_planned", min:0, step: 100, unit:"kwh/Jahr", placeholder:"1200 kwh/Jahr", default: undefined},
    {key: "gasverbrauch_m3_planned", label: "Gasverbrauch", type: "number_verbrauch_planned", min:0, step: 1, unit:"m³/Jahr", placeholder:"1200 m³/Jahr", default: undefined},
    {key: "holzverbrauch_planned", label: "Verbrauch von Pettets / Holz", type: "number_verbrauch_planned", min:0, step: 100, unit:"kWH/Jahr", placeholder:"1200 kWh/Jahr", default: undefined},
    {key: "holzverbrauch_m3_planned", label: "Verbrauch von Pettets / Holz", type: "number_verbrauch_planned", min:0, step: 1, unit:"m³/Jahr", placeholder:"1200 m³/Jahr", default: undefined},
    {key: "holzverbrauch_t_planned", label: "Verbrauch von Pettets / Holz", type: "number_verbrauch_planned", min:0, step: 1, unit:"t/Jahr", placeholder:"1200 t/Jahr", default: undefined},
    {key: "holzverbrauch_kg_planned", label: "Verbrauch von Pettets / Holz", type: "number_verbrauch_planned", min:0, step: 100, unit:"kg/Jahr", placeholder:"1200 kg/Jahr", default: undefined},
    {key: "stromverbrauchdiodenheizung_planned", label: "Stromverbrauch", type: "number_verbrauch_planned", min:0, step: 100, unit:"kwh/Jahr", placeholder:"1200 kwh/Jahr", default: undefined},
    {key: "stromverbrauchwaermepumpe_planned", label: "Verbrauch Wärmepumpe", type: "number_verbrauch_planned", min:0, step: 100, unit:"kwh/Jahr", placeholder:"1200 kwh/Jahr", default: undefined},
    {key: "stromverbrauch_planned", label: "Stromverbrauch", type: "number_verbrauch_planned", min:0, step: 100, unit:"kwh/Jahr", placeholder:"1200 kwh/Jahr", default: undefined},

    
    {key: "budget", label: "Budget", type: "number", min:500, step: 500,unit:"€", placeholder:"1200 €", default: undefined},
    {key: "massnamen_empfehlen", label: "Maßnamen empfehlen", type: "boolean", default: undefined},
    {key: "beheizte_segmente", label: "Beheizte Bereiche", hint: "Werte durch klicken und ziehen oder eintippen einstellen.", type: "heated_segments", default: [0,100,0]},
    {key: "darlehen", label: "Darlehenskosten pauschal", type: "number", min:0, step: 500, unit:"€", placeholder:"150000 €", default: undefined},
    
    {key: "kostensteigerung_energie", label: "Kostensteigerung Energie", decimals: 1, min: 0, max: 1000, type: "number", unit:"%", placeholder:"3 %", step:0.1, default: 3},
    {key: "co2_price", label: "CO₂ Preis", type: "number", unit:"€/t", placeholder:"65 €", min:0, max:1000, step:5, default: 65},

    {key: "heizung", label: "Heizung", type: "options", options_key: "heating_system", options_state:"current_state", options: MASSNAHMEN_HEIZUNG_OPTIONS_CURRENT, default: MASSNAHMEN_HEIZUNG_OPTIONS_CURRENT[0].value},
    {key: "heizung_future", label: "geplante Heizung", type: "options", options_key: "heating_system", options_state:"planned_state", options: MASSNAHMEN_HEIZUNG_OPTIONS_NEW, default: MASSNAHMEN_HEIZUNG_OPTIONS_NEW[0].value},
    {key: "heizung_datum", label: "Einbaujahr", type: "year" , placeholder:"1987" , default: undefined},
    {key: "heizung_kosten", label: "Kosten", type: "number", step: 500,min:0, unit:"€", placeholder:"10000 €", default: undefined},
    {key: "heizung_isfp", label: "individueller Sanierungsfahrplan", type: "boolean", default: undefined},
    {key: "heizung_natural_refrigerant", label: "natürliches Kältemittel<br>+5% Effizienzbonus", type: "boolean", default: undefined},
    {key: "heizung_natural_refrigerant_future", label: "natürliches Kältemittel<br>+5% Effizienzbonus", type: "boolean", default: undefined},
    {key: "heizung_dust_emission", label: "erfüllt Staub-Emissionsgrenzwert (2,5 mg/m³)<br>+2.500 € Emissionsminderungs-Zuschlag", type: "boolean", default: undefined},
    {key: "hot_water", label: "Heißwasser", type: "options", options: HOTWATER_OPTIONS, default: HOTWATER_OPTIONS[0].value},


    {key: "income_gt_4k", label: "Jährliches Haushalts-Einkommen"/*"Zu versteuerndes Haushalts-Jahres-Einkommen"*/, type: "options", options: EINKOMMENSBONUS, default: EINKOMMENSBONUS[0].value},
    {key: "heizung_wird_ausgetauscht", label: "funktionierenden Altheizung wird ausgebaut<br> <b> +16 % Klimageschwindigkeitsbonus</b>,<br>sinkt alle 6 Monate um 4%", type: "boolean", default: undefined},
    
    {key: "keller", label: "Keller", type: "options", options_key: "floor_insulation", options_state:"current_state", options: MASSNAHMEN_KELLER_OPTIONS_CURRENT, default: MASSNAHMEN_KELLER_OPTIONS_CURRENT[0].value},
    {key: "keller_future", label: "geplanter Keller", type: "options", options_key: "floor_insulation", options_state:"planned_state", options: MASSNAHMEN_KELLER_OPTIONS_NEW, default: MASSNAHMEN_KELLER_OPTIONS_NEW[0].value},
    {key: "keller_datum", label: "Einbaujahr", type: "year" , placeholder:"1987" , default: undefined},
    {key: "keller_kosten", label: "Kosten",  type: "number", step: 500 ,min:0, unit:"€", placeholder:"10000 €", default: undefined},
    {key: "keller_isfp", label: "individueller Sanierungsfahrplan", type: "boolean", default: undefined},

    {key: "dach", label: "Dach", type: "options", options_key: "roof_insulation", options_state:"current_state", options: MASSNAHMEN_DACH_OPTIONS_CURRENT,  default: MASSNAHMEN_DACH_OPTIONS_CURRENT[0].value},
    {key: "dach_future", label: "geplantes Dach", type: "options", options_key: "roof_insulation", options_state:"planned_state", options: MASSNAHMEN_DACH_OPTIONS_NEW,  default: MASSNAHMEN_DACH_OPTIONS_NEW[0].value},

    // {key: "dach_future_schraege", label: "geplante Neigungswinkel", type: "options", options: MASSNAHMEN_DACH_OPTIONS_NEW_SPARREN,  default: MASSNAHMEN_DACH_OPTIONS_NEW_SPARREN[0].value},
    // {key: "dach_future_decke", label: "geplantes Oberste Geschoßdecke", type: "options", options: MASSNAHMEN_DACH_OPTIONS_NEW_DECKE,  default: MASSNAHMEN_DACH_OPTIONS_NEW_DECKE[0].value},
    {key: "dach_datum", label: "Einbaujahr", type: "year" , placeholder:"1987" , default: undefined},
    {key: "dach_kosten", label: "Kosten",  type: "number", step: 500, min:0, unit:"€", placeholder:"10000 €", default: undefined},
    {key: "dach_isfp", label: "individueller Sanierungsfahrplan", type: "boolean", default: undefined},

    {key: "fenster", label: "Fenster", type: "options", options_key: "window", options_state:"current_state", options: MASSNAHMEN_FENSTER_OPTIONS_CURRENT, default: MASSNAHMEN_FENSTER_OPTIONS_CURRENT[0].value},
    {key: "fenster_future", label: "geplante Fenster", type: "options", options_key: "window", options_state:"planned_state", options: MASSNAHMEN_FENSTER_OPTIONS_NEW, default: MASSNAHMEN_FENSTER_OPTIONS_NEW[0].value},
    {key: "fenster_datum", label: "Einbaujahr", type: "year" , placeholder:"1987" , default: undefined},
    {key: "fenster_kosten", label: "Kosten",  type: "number", step: 500, min:0, unit:"€", placeholder:"10000 €", default: undefined},
    {key: "fenster_isfp", label: "individueller Sanierungsfahrplan", type: "boolean", default: undefined},

    {key: "fassade", label: "Fassade", type: "options", options_key: "facade_insulation", options_state:"current_state", options: MASSNAHMEN_FASSADE_OPTIONS_CURRENT, default: MASSNAHMEN_FASSADE_OPTIONS_CURRENT[0].value},
    {key: "fassade_future", label: "geplante Fassade", type: "options", options_key: "facade_insulation", options_state:"planned_state", options: MASSNAHMEN_FASSADE_OPTIONS_NEW, default: MASSNAHMEN_FASSADE_OPTIONS_NEW[0].value},
    {key: "fassade_datum", label: "Einbaujahr", type: "year" , placeholder:"1987" , default: undefined},
    {key: "fassade_kosten", label: "Kosten",  type: "number", step: 500, min:0, unit:"€", placeholder:"10000 €", default: undefined},
    {key: "fassade_isfp", label: "individueller Sanierungsfahrplan", type: "boolean", default: undefined},

    {key: "solarthermie", label: "Solarthermie", type: "options", options_key: "solar_thermal", options_state:"current_state", options: MASSNAHMEN_SOLARTHERMIE_OPTIONS_CURRENT, default: MASSNAHMEN_SOLARTHERMIE_OPTIONS_CURRENT[0].value},
    {key: "solarthermie_future", label: "geplante Solarthermie", type: "options", options_key: "solar_thermal", options_state:"planned_state", options: MASSNAHMEN_SOLARTHERMIE_OPTIONS_NEW, default: MASSNAHMEN_SOLARTHERMIE_OPTIONS_NEW[0].value},
    {key: "solarthermie_datum", label: "Einbaujahr", type: "year" , placeholder:"1987" , default: undefined},
    {key: "solarthermie_kosten", label: "Kosten",  type:  "number", step:500, min:0, unit:"€", placeholder:"10000 €", default: undefined},
    {key: "solarthermie_kollektorflaeche", label: "Kollektorfläche", decimals: 1, placeholder:"30 m²", min:0, max: 1000, type: "number", step:0.1 ,unit:"m²", default: undefined},
    {key: "solarthermie_speichergroesse", label: "Speichergröße", placeholder:"30 m²", type:  "number", step:0.1, min:0, max: 1000, unit:"kwh",  default: undefined},
    {key: "solarthermie_kollektorflaeche_future", label: "Kollektorfläche", decimals: 1, placeholder:"30 m²", type:  "number", step:0.1, min:0, max: 1000, unit:"m²", default: undefined},
    {key: "solarthermie_speichergroesse_future", label: "Speichergröße", type:  "number", step:1, min:0, max: 1000, unit:"kwh", default: undefined},
    {key: "solarthermie_isfp", label: "individueller Sanierungsfahrplan", type: "boolean", default: undefined},

    {key: "solarthermie_roof_pitch", label: "Neigungswinkel", placeholder:"40°", type: "number", step:5, unit:"°", default: undefined},
    {key: "solarthermie_orientation", label: "Ausrichtung", type: "options", options:ROOF_ORIENTATIONS, default:ROOF_ORIENTATIONS[0].value},
    {key: "solarthermie_roof_pitch_future", label: "Neigungswinkel", placeholder:"40°", type: "number", step:5, unit:"°", default: undefined},
    {key: "solarthermie_orientation_future", label: "Ausrichtung", type: "options", options:ROOF_ORIENTATIONS, default:ROOF_ORIENTATIONS[0].value},
    {key: "solarthermie_natural_refrigerant", label: "Kühlmittel", type: "boolean", default: undefined},

    {key: "photovoltaik", label: "Photovoltaik", type: "options", options_key: "photovoltaics", options_state:"current_state", options: MASSNAHMEN_PHOTOVOLTAIK_OPTIONS_CURRENT, default: MASSNAHMEN_PHOTOVOLTAIK_OPTIONS_CURRENT[0].value},
    {key: "photovoltaik_future", label: "geplante Photovoltaik", type: "options", options_key: "photovoltaics", options_state:"planned_state", options: MASSNAHMEN_PHOTOVOLTAIK_OPTIONS_NEW, default: MASSNAHMEN_PHOTOVOLTAIK_OPTIONS_NEW[0].value},
    {key: "photovoltaik_datum", label: "Einbaujahr", type: "year" , placeholder:"1987" , default: undefined},
    {key: "photovoltaik_kosten", label: "Kosten", type:  "number", step:500, min:0, unit:"€", placeholder:"10000 €", default: undefined},
    {key: "photovoltaik_isfp", label: "individueller Sanierungsfahrplan", type: "boolean", default: undefined},

    {key: "photovoltaik_roof_pitch", label:"Neigungswinkel", type: "number", placeholder:"40°", step:5, min:0, max: 180, unit:"°",  default:undefined},
    {key: "photovoltaik_orientation", label:"Ausrichtung", type: "options", options:ROOF_ORIENTATIONS, default:ROOF_ORIENTATIONS[0].value},
    {key: "photovoltaik_annual_yield_kWh", label:"Ertrag (jährlich)", placeholder:"1000 kWh/a",unit:"kWh/a", type: "number", step:500,  default:undefined},
    {key: "photovoltaik_battery_storage", label:"Batteriespeicher vorhanden", type: "boolean", step:500,  default:undefined},
    {key: "photovoltaik_roof_pitch_future", label:"Neigungswinkel", placeholder:"40°", type: "number", step:5, min:0, max: 180, unit:"°",  default:undefined},
    {key: "photovoltaik_orientation_future", label:"Ausrichtung", type: "options", options:ROOF_ORIENTATIONS, default:ROOF_ORIENTATIONS[0].value},
    {key: "photovoltaik_battery_storage_future", label:"Batteriespeicher hinzufügen", type: "boolean", step:500,  default:undefined},

    {key: "lueftung", label: "Lüftung", type: "options", options_key: "ventilation_system", options_state:"current_state", options: MASSNAHMEN_LUEFTUNG_OPTIONS_CURRENT, default: MASSNAHMEN_LUEFTUNG_OPTIONS_CURRENT[0].value},
    {key: "lueftung_future", label: "geplante Lüftung", type: "options", options_key: "ventilation_system", options_state:"planned_state", options: MASSNAHMEN_LUEFTUNG_OPTIONS_NEW, default: MASSNAHMEN_LUEFTUNG_OPTIONS_NEW[0].value},
    {key: "lueftung_datum", label: "Einbaujahr", type: "year" , placeholder:"1987" , default: undefined},
    {key: "lueftung_kosten", label: "Kosten",  type: "number", step: 500, min:0,unit:"€", placeholder:"10000 €", default: undefined},
    {key: "lueftung_isfp", label: "individueller Sanierungsfahrplan", type: "boolean", default: undefined},


  ];

export const MAIN_PROPERTIES_DEFAULT = MAIN_PROPERTIES.reduce((acc: Partial<Record<MainPropertyKey, MainPropertyValue>>, value : MainPropertiesDeclare)=>{
  acc[value.key] = value.default;
  return acc;
}, {}) as MainProperties;

export const MAIN_PROPERTY_LABELS = MAIN_PROPERTIES.reduce((acc: Partial<Record<MainPropertyKey, string>>, value : MainPropertiesDeclare)=>{
  acc[value.key] = value.label;
  return acc;
}, {});

export const MAIN_PROPERTY_HINTS = MAIN_PROPERTIES.reduce((acc: Partial<Record<MainPropertyKey, string>>, value : MainPropertiesDeclare)=>{
  acc[value.key] = value.hint;
  return acc;
}, {});

export const MAIN_PROPERTY_PLACEHOLDERS = MAIN_PROPERTIES.reduce((acc: Partial<Record<MainPropertyKey, string>>, value : MainPropertiesDeclare)=>{
  acc[value.key] = value.placeholder;
  return acc;
}, {});

export type RoofOrientation = "N" | "S" | "O" | "W" |  "NW" | "NO" | "SW" | "SO";


  export interface MainProperties{
    verbrauchseinheit_oel_current: "liter";
    verbrauchseinheit_gas_current: "kWh" | "m3";
    verbrauchseinheit_holz_current: "m3" | "t" | "kg";
    verbrauchseinheit_andere_current: "kWh";
    verbrauchseinheit_oel_planned: "liter";
    verbrauchseinheit_gas_planned: "kWh" | "m3";
    verbrauchseinheit_holz_planned: "m3" | "t" | "kg";
    verbrauchseinheit_andere_planned: "kWh";
    energie_kosten_current?: number;
    energie_kosten_planned?: number;
    income_gt_4k?:boolean;
    heizung_wird_ausgetauscht?: boolean;
    gebaeude_typ?: GebaeudeTyp;
    postleitzahl?: string;
    strasse?: string;
    hausnummer?: number;
    vollgeschosse?: number;
    wohneinheiten?: number;
    baujahr? : number;
    baujahr_base? : number;
    wohnflaeche?: number;
    oelverbrauch?: number;
    stromverbrauch? : number;
    gasverbrauch?: number;
    stromverbrauchdiodenheizung?: number;
    holzverbrauch?: number;
    gasverbrauch_m3?: number;
    holzverbrauch_t?: number;
    holzverbrauch_m3?: number;
    holzverbrauch_kg?: number;
    stromverbrauchwaermepumpe?: number;
    budget?: number;
    privat: boolean;
    massnamen_empfehlen?: boolean;
    beheizte_segmente?: HeatedSegment;
    darlehen?: number; 
    kostensteigerung_energie?: number;
    co2_price?: number;

    heizung?: string;
    heizung_future?: string;
    heizung_datum?: number;
    heizung_kosten?: number;
    heizung_isfp: boolean;
    heizung_natural_refrigerant: boolean;
    heizung_natural_refrigerant_future: boolean;
    heizung_dust_emission: boolean;
    hot_water: string;

    keller?: string;
    keller_future?: string;
    keller_datum?: number;
    keller_kosten?: number;
    keller_isfp: boolean;

    dach?: string;
    dach_future?: string;

    // dach_future_schraege?: string;
    // dach_future_decke?: string;
    dach_datum?: number;
    dach_kosten?: number;
    dach_isfp: boolean;

    fenster?: string;
    fenster_future?: string;
    fenster_datum?: number;
    fenster_kosten?: number;
    fenster_isfp: boolean;

    fassade?: string;
    fassade_future?: string;
    fassade_datum?: number;
    fassade_kosten?: number;
    fassade_isfp: boolean;

    solarthermie?: string;
    solarthermie_future?: string;
    solarthermie_datum?: number;
    solarthermie_kosten?: number;
    solarthermie_kollektorflaeche: number,
    solarthermie_speichergroesse: number,
    solarthermie_kollektorflaeche_future: number,
    solarthermie_speichergroesse_future: number,
    solarthermie_isfp: boolean;

    photovoltaik?: string;
    photovoltaik_future?: string;
    photovoltaik_datum?: number;
    photovoltaik_kosten?: number;
    photovoltaik_isfp: boolean;

    lueftung?: string;
    lueftung_future?: string;
    lueftung_datum?: number;
    lueftung_kosten?: number;
    lueftung_isfp: boolean;

    solarthermie_roof_pitch?: number;
    solarthermie_orientation?: RoofOrientation;
    solarthermie_roof_pitch_future?: number;
    solarthermie_orientation_future?: RoofOrientation;
    solarthermie_natural_refrigerant?: number;
    photovoltaik_roof_pitch?: number;
    photovoltaik_orientation?: RoofOrientation;
    photovoltaik_annual_yield_kWh?: number;
    photovoltaik_battery_storage?: number;
    photovoltaik_roof_pitch_future?: number;
    photovoltaik_orientation_future?: RoofOrientation;
    photovoltaik_battery_storage_future?: number;
};

export type MainPropertyKey = keyof MainProperties;

                      
export type HeatedSegment = [number, number, number];
export type MainPropertyValue = string | number | boolean | GebaeudeTyp | HeatedSegment | undefined; 